export default __webpack_public_path__ + "static/media/bullseye.e5ead155.svg";